import { render, staticRenderFns } from "./groupCustomer_us.vue?vue&type=template&id=600aebef"
import script from "./groupCustomer_us.vue?vue&type=script&lang=js"
export * from "./groupCustomer_us.vue?vue&type=script&lang=js"
import style0 from "./groupCustomer_us.vue?vue&type=style&index=0&id=600aebef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports